import { render, staticRenderFns } from "./LPFooter.vue?vue&type=template&id=74f73552&scoped=true"
import script from "./LPFooter.vue?vue&type=script&lang=js"
export * from "./LPFooter.vue?vue&type=script&lang=js"
import style0 from "./LPFooter.vue?vue&type=style&index=0&id=74f73552&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f73552",
  null
  
)

export default component.exports